import axios from 'axios';
import React from 'react'
import { useParams } from "react-router-dom";
import { BASE_URL } from '../../../../Screens/Settings/DASHBOARD_SETTINGS';
import { toast } from "react-toastify";
import { Button, buttonVariants } from '../../../Global/UI/Button';
import { ThreeDots } from 'react-loader-spinner'
import { useHistory } from 'react-router-dom';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogClose, DialogDescription } from '../../../../Components/Global/UI/Dialog';
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem } from "../../../../Components/Global/UI/Command"
import { Popover, PopoverContent, PopoverTrigger } from "../../../../Components/Global/UI/Popover"
import { Check, ChevronsUpDown } from "lucide-react"
import ViewPatientDetails from './ViewPatientDetails';
import ViewTrustDetails from './ViewTrustDetails';
import ViewJourneyDetails from './ViewJourneyDetails';


const ViewRenalDetails = () => {

    const [isDialogOpen, setIsDialogOpen] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const { JobID } = useParams();
    const [jobDetails, setJobDetails] = React.useState({
        itemId: '',
        referenceCode: '',
        jobDetails: {},
        jobs: {},
        patientDetails: {},
    });
    const [loading, setLoading] = React.useState(true);
    const history = useHistory()
    const [selectedDriverUsername, setSelectedDriverUsername] = React.useState("");
    const [drivers, setDrivers] = React.useState(null);

    const handleAssignJob = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/api/nias-renal/assignJob/${selectedDriverUsername.toUpperCase()}/${jobDetails.itemId}`);
            if (response.data.success) {
                toast.success(`Sucessfully Assigned Job: ${jobDetails.itemId}.`);
            }
        } catch (error) {
            if (error.response) {
                if (error.response.status === 404) {
                    toast.error(error.response.data.message);
                    console.error('Item not found:', error.response.data.message);
                }
            } else if (error.request) {
                toast.error("An unknown error has occured");
                console.error('No response received:', error.request);
            } else {
                toast.error("An unknown error has occured");
                console.error('Error setting up the request:', error.message);
            }
        }
    };

    const fetchDrivers = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/api/drivers/getDrivers`);
            if (response.data.success) {
                setDrivers(response.data.drivers);
            }
        } catch (error) {
            console.error('Error fetching drivers:', error.message);
            toast.error('Failed to fetch drivers');
        }
    };

    const handleCloseDialog = () => {
        setIsDialogOpen(false);
    };

    const handleJobDetailsChange = (data) => {
        setJobDetails(prevJobDetails => ({
            ...prevJobDetails,
            jobDetails: data
        }));
    };


    const handlePatientDetailsChange = (data) => {
        setJobDetails(prevJobDetails => ({
            ...prevJobDetails,
            patientDetails: data
        }));
    };

    const handleJourneyDetailsChange = (data) => {
        setJobDetails(prevJobDetails => ({
            ...prevJobDetails,
            jobs: data
        }));
    };


    const handleJobDelete = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/api/nias-renal/${jobDetails.itemId}/remove-request`);
            if (response.data.success) {
                toast.success(response.data.msg);
                history.push('/')
            }
        } catch (error) {
            if (error.response) {
                if (error.response.status === 400) {
                    toast.error(error.response.data.msg);
                    console.error('Validation errors:', error.response.data.msg);
                }
            } else if (error.request) {
                toast.error("An unknown error has occured");
                console.error('No response received:', error.request);
            } else {
                toast.error("An unknown error has occured");
                console.error('Error setting up the request:', error.msg);
            }
        }
    }

    const cancelJob = async (status) => {
        try {
            const response = await axios.get(`${BASE_URL}/api/nias-renal/${jobDetails.itemId}/cancel-job`);
            if (response.data.success) {
                toast.success(response.data.msg);
                history.push('/')
            }
        } catch (error) {
            if (error.response) {
                if (error.response.status === 400) {
                    toast.error(error.response.data.message);
                    console.error('Validation errors:', error.response.data.errors);
                }
            } else if (error.request) {
                toast.error("An unknown error has occured");
                console.error('No response received:', error.request);
            } else {
                toast.error("An unknown error has occured");
                console.error('Error setting up the request:', error.message);
            }
        }
    }

    const handleUpdateJob = async () => {
        try {
            const response = await axios.post(`${BASE_URL}/api/nias-renal/${jobDetails.itemId}/updateRequest`, jobDetails);
            if (response.data.success) {
                toast.success(response.data.msg);
                fetchData()
            }
        } catch (error) {
            if (error.response) {
                if (error.response.status === 404) {
                    toast.error(error.response.data.message);
                    console.error('Item not found:', error.response.data.message);
                }
            } else if (error.request) {
                toast.error("An unknown error has occured");
                console.error('No response received:', error.request);
            } else {
                toast.error("An unknown error has occured");
                console.error('Error setting up the request:', error.message);
            }
        }
    };

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await axios.get(
                `${BASE_URL}/api/nias-renal/job/${JobID}`
            );
            console.log('Job Details:',response.data)
            if (response.data.success) {
                setLoading(false);
                console.log('Response Data:', response.data)
                setJobDetails({
                    itemId: response.data.job._id || '',
                    referenceCode: response.data.job.jobDetails.referenceCode || '',
                    jobDetails: response.data.job.jobDetails || {},
                    jobs: response.data.job.jobs || {},
                    patientDetails: response.data.job.patientDetails || {},
                });
            }
        } catch (error) {
            if (error.response) {
                if (error.response.status === 404) {
                    setLoading(false);
                    toast.error(error.response.data.message);
                    console.error("Item not found:", error.response.data.message);
                }
            } else if (error.request) {
                setLoading(false);
                toast.error("An unknown error has occurred");
                console.error("No response received:", error.request);
            } else {
                setLoading(false);
                toast.error("An unknown error has occurred");
                console.error("Error setting up the request:", error.message);
            }
        }
    };
    React.useEffect(() => {
        fetchData();
        fetchDrivers();
    }, []);



    if (loading) {
        return (
            <div className="flex justify-center items-center h-screen">
                <ThreeDots
                    height="80"
                    width="80"
                    color="#000000"
                    ariaLabel="tail-spin-loading"
                    radius="1"
                    visible={true}
                />
            </div>
        );
    }

    return (
        <div className="full-overview m-10">

            <Dialog open={isDialogOpen} onOpenChange={handleCloseDialog}>
                <DialogContent>
                    <DialogHeader>
                        <DialogTitle>Assign an ambulance</DialogTitle>
                        <DialogClose />
                    </DialogHeader>
                    <DialogDescription>
                        Assign an ambulance to this job.
                    </DialogDescription>
                    {drivers && (
                        <Popover open={open} onOpenChange={setOpen} >
                            <PopoverTrigger asChild>
                                <Button
                                    variant="outline"
                                    role="combobox"
                                    aria-expanded={open}
                                    className="w-auto justify-between"
                                >
                                    {selectedDriverUsername ? selectedDriverUsername.toUpperCase() : "Select Driver..."}
                                    <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
                                </Button>
                            </PopoverTrigger>
                            <PopoverContent className="w-full p-0">
                                <Command>
                                    <CommandInput placeholder="Search Driver..." />
                                    <CommandEmpty>No Driver found.</CommandEmpty>
                                    <CommandGroup>
                                        {drivers.map((framework) => (
                                            <CommandItem
                                                key={framework.username}
                                                value={framework.username}
                                                onSelect={(currentValue) => {
                                                    const newSelectedDriver = currentValue === selectedDriverUsername ? "" : currentValue;
                                                    setSelectedDriverUsername(newSelectedDriver);
                                                    setOpen(false);
                                                }}
                                            >
                                                <Check
                                                    className={`mr-2 h-4 w-4 ${selectedDriverUsername.toUpperCase() === framework.username ? "opacity-100" : "opacity-0"}`}
                                                />
                                                {framework.username}
                                            </CommandItem>
                                        ))}
                                    </CommandGroup>
                                </Command>
                            </PopoverContent>
                        </Popover>
                    )}
                    <Button
                        variant="default"
                        size="lg"
                        className={buttonVariants({ variant: "default", size: "lg" })}
                        onClick={() => handleAssignJob()}>
                        Assign Job
                    </Button>
                </DialogContent>
            </Dialog>


            <div className='flex flex-row justify-between'>
                {console.log(jobDetails)}
                <h2 className='font-semibold text-3xl'>Booking Overview - {jobDetails.referenceCode.toUpperCase()}</h2>
                <div>
                    {jobDetails.jobtimestamps && (
                        <Button
                            variant="default"
                            size="lg"
                            className={`${buttonVariants({ variant: "default", size: "lg" })} mr-2`}
                        // onClick={() => handleLogClick()}
                        >
                            View Log
                        </Button>
                    )}

                    <Button
                        variant="default"
                        size="lg"
                        className={buttonVariants({ variant: "default", size: "lg" })}
                        onClick={() => handleUpdateJob()}
                    >
                        Save Changes
                    </Button>
                    <Button
                        variant="default"
                        size="lg"
                        className={`${buttonVariants({ variant: "default", size: "lg" })} ml-2`}
                        onClick={() => setIsDialogOpen(true)}
                    >
                        Assign Job
                    </Button>
                    <Button
                        variant="default"
                        size="lg"
                        className={`${buttonVariants({ variant: "default", size: "lg" })} ml-2`}
                        onClick={() => cancelJob()}
                    >
                        Cancel Job
                    </Button>
                    <Button
                        variant="default"
                        size="lg"
                        className={`${buttonVariants({ variant: "default", size: "lg" })} ml-2`}
                        onClick={() => handleJobDelete()}
                    >
                        Delete Job
                    </Button>
                </div>
            </div>

            <div className='mt-6'>
            <ViewTrustDetails data={jobDetails.jobDetails} onChange={handleJobDetailsChange} />
            <ViewPatientDetails data={jobDetails.patientDetails} onChange={handlePatientDetailsChange}  />
            <ViewJourneyDetails data={jobDetails.jobs} onChange={handleJourneyDetailsChange} />
            </div>
        </div >
    )
};

export default ViewRenalDetails;
